exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-center{text-align:center}.text-right{text-align:right}.text-left{text-align:left}.text-primary{color:#128dff;color:var(--color-primary)}.text-strong{color:#ff762e;color:var(--color-strong)}.text-danger{color:#f64343;color:var(--color-danger)}.text-success{color:#67c23a;color:var(--color-success)}.text-gray-1{color:#333;color:var(--color-font-1)}.text-gray-2{color:#666;color:var(--color-font-2)}.text-gray-3{color:#999;color:var(--color-font-3)}.text-delete,.text-gray-4{color:#ccc;color:var(--color-font-4)}", ""]);

// exports
